import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import PopUpContent from "./PopUpContent";

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: React.ReactNode;
  actions?: React.ReactNode;
}

const PopUp: React.FC<Props> = ({ open, onClose, title, content, actions }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="popup-title"
      aria-describedby="popup-content"
      
    >
      {title && <DialogTitle id="popup-title">{title}</DialogTitle>}
      <DialogContent id="popup-content">
        {content || <PopUpContent></PopUpContent>}
      </DialogContent>  
      <DialogActions>
        {actions || <Button onClick={onClose}>Fechar</Button>}
      </DialogActions>
    </Dialog>
  );
};

export default PopUp;
